import Chip from "@mui/material/Chip"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import {
  REPORT_DATE_PRESET,
  buildReportDateRange,
} from "./reportDateRangePresets"

const PRESET_OPTIONS = [
  { id: REPORT_DATE_PRESET.today, label: "Today" },
  { id: REPORT_DATE_PRESET.yesterday, label: "Yesterday" },
  { id: REPORT_DATE_PRESET.lastWeek, label: "Last week" },
  { id: REPORT_DATE_PRESET.last30Days, label: "Last 30 days" },
  { id: REPORT_DATE_PRESET.custom, label: "Custom" },
]

export default function AdminReportDateRangePicker({
  value,
  onChange,
  includeAll = false,
  helperText = "",
}) {
  const presetOptions = includeAll
    ? [{ id: REPORT_DATE_PRESET.all, label: "All dates" }, ...PRESET_OPTIONS]
    : PRESET_OPTIONS

  function handlePresetSelect(preset) {
    if (preset === REPORT_DATE_PRESET.custom) {
      onChange(
        buildReportDateRange(
          REPORT_DATE_PRESET.custom,
          value.from || "",
          value.to || value.from || ""
        )
      )
      return
    }
    onChange(buildReportDateRange(preset))
  }

  function handleCustomDateChange(field, nextValue) {
    onChange(
      buildReportDateRange(
        REPORT_DATE_PRESET.custom,
        field === "from" ? nextValue : value.from,
        field === "to" ? nextValue : value.to
      )
    )
  }

  return (
    <Column gap={1.25} sx={{ minWidth: { xs: "100%", md: 320 } }}>
      <Row gap={1} sx={{ flexWrap: "wrap" }}>
        {presetOptions.map((option) => (
          <Chip
            key={option.id}
            label={option.label}
            clickable
            color={value.preset === option.id ? "primary" : "default"}
            variant={value.preset === option.id ? "filled" : "outlined"}
            onClick={() => handlePresetSelect(option.id)}
          />
        ))}
      </Row>
      {value.preset === REPORT_DATE_PRESET.custom ? (
        <Row gap={1.5} sx={{ flexWrap: "wrap" }}>
          <TextField
            size="small"
            type="date"
            label="From"
            value={value.from || ""}
            onChange={(event) =>
              handleCustomDateChange("from", event.target.value)
            }
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 160 }}
          />
          <TextField
            size="small"
            type="date"
            label="To"
            value={value.to || ""}
            onChange={(event) =>
              handleCustomDateChange("to", event.target.value)
            }
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 160 }}
          />
        </Row>
      ) : null}
      {helperText ? (
        <Typography variant="caption" color="text.secondary">
          {helperText}
        </Typography>
      ) : null}
    </Column>
  )
}
